import {
    FilterType,
} from 'app/enums/common.enums'
import {
    FilterConfig,
} from 'app/hooks/useFilter'
import {
    AdditionalFeesTable,
} from '../../RateCards/AdditionalFees/AdditionalFees.types'

const filterConfig: FilterConfig<keyof Pick<AdditionalFeesTable,
    'currency'>> = {
        currency: {
            filterField: 'currency',
            filterType: FilterType.Array,
        },
    }

export default filterConfig
